export const dataBabks = {
    "banks": [
        {
            "mkey": "00",
            "mtext": "בנק מזרחי טפחות",
            "mEngText": "בנק מזרחי טפחות"
        },
        {
            "mkey": "01",
            "mtext": "בנק הפועלים",
            "mEngText": "בנק הפועלים"
        }, {
            "mkey": "02",
            "mtext": "בנק לאומי",
            "mEngText": "בנק לאומי"
        }, {
            "mkey": "03",
            "mtext": "בנק דיסקונט",
            "mEngText": "בנק דיסקונט"
        }, {
            "mkey": "04",
            "mtext": "בנק הבינלאומי",
            "mEngText": "בנק הבינלאומי"
        }, {
            "mkey": "06",
            "mtext": "בנק ירושלים",
            "mEngText": "בנק ירושלים"
        }, {
            "mkey": "07",
            "mtext": "בנק מרכנתיל",
            "mEngText": "בנק מרכנתיל"
        }, {
            "mkey": "08",
            "mtext": "טריא",
            "mEngText": "טריא"
        }, {
            "mkey": "09",
            "mtext": "מגדל",
            "mEngText": "מגדל"
        }, {
            "mkey": "10",
            "mtext": "אילון",
            "mEngText": "אילון"
        }, {
            "mkey": "11",
            "mtext": "AMG",
            "mEngText": "AMG"
        }, {
            "mkey": "12",
            "mtext": "מנורה",
            "mEngText": "מנורה"
        }, {
            "mkey": "13",
            "mtext": "קרן אקספו",
            "mEngText": "קרן אקספו"
        }, {
            "mkey": "14",
            "mtext": "כלל",
            "mEngText": "כלל"
        }, {
            "mkey": "15",
            "mtext": "אחר",
            "mEngText": "אחר"
        }
    ]
}


// WEBPACK FOOTER //
// ./src/app/banks.ts